import Formatter from 'utils/Formatter';
import './InquiryList.style.css';

const InquiryList = ({ inquiryList, emptyMessage, navigate }) => {
  return (
    <div>
      <div
        className="wrap"
        style={{
          minHeight: 292, // 데이터 2개 높이에 맞춘 최소 높이 설정
          display: 'flex',
          flexDirection: 'column',
          justifyContent: inquiryList.length ? 'flex-start' : 'center',
          alignItems: inquiryList.length ? 'flex-start' : 'center',
          padding: inquiryList.length ? '0' : '32px',
          borderBottom: inquiryList.length
            ? 'none'
            : '1px solid var(--light-gray-color)',
        }}
      >
        {inquiryList.length > 0 ? (
          inquiryList.map((item, index) => (
            <div
              className="item"
              key={`inquiryList_${index}_${item.inquiry_id}`}
              style={{
                width: '100%',
                padding: '32px 0',
                borderBottom: '1px solid var(--light-gray-color)',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  marginBottom: 16,
                  fontSize: 14,
                  color: '#999',
                }}
              >
                <span style={{ fontSize: 14, color: '#999' }}>
                  {Formatter.unixToDate(item.created_at, 'YYYY.MM.DD')}
                </span>
              </div>
              <span
                className="tag"
                style={{
                  fontSize: 14,
                  width: 'fit-content',
                  padding: '2px 8px',
                  border: '1px solid var(--black-color)',
                  marginBottom: 8,
                  backgroundColor:
                    item.status === 'DONE'
                      ? 'var(--black-color)'
                      : 'transparent',
                  color: item.status === 'DONE' ? '#fff' : 'var(--black-color)',
                }}
              >
                {item.status === 'DONE' ? '답변완료' : '답변대기'}
              </span>
              <span>{item.inquiry_name}</span>
            </div>
          ))
        ) : (
          <span
            style={{
              fontSize: 16,
              color: '#999',
              textAlign: 'center',
            }}
          >
            {emptyMessage}
          </span>
        )}
      </div>
    </div>
  );
};

export default InquiryList;
